import { render, staticRenderFns } from "./WDGSlider.vue?vue&type=template&id=1c738a72&"
import script from "./WDGSlider.vue?vue&type=script&lang=js&"
export * from "./WDGSlider.vue?vue&type=script&lang=js&"
import style0 from "./WDGSlider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../prospect-setup/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports